export default {
  address: 'Adresse *',
  'create-account-247-support': '24/7 Support',
  'create-account-secure': '100% sikkert',
  'create-account-fast': 'Raske og enkle uttak',
  'create-account-gambling-commission': 'Gambling Commission',
  // 'create-account-success-heading': 'Congratulations',
  // 'create-account-success-welcome': 'Welcome',
  // 'create-account-success-body-text': 'We’re thrilled to have you with us!',
  // 'create-account-success-bonus-claim': 'Claim your bonus',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Velkomstbonusen opp til',
  'create-account-promotion-description': `##UPTO_AMOUNT## på ditt første innskudd`,
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## Spins',

  //need translations!
  'create-account-promotion-sign-in': 'Har du allerede en konto?',
  'create-account-close': 'Lukk',

  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Vilkår gjelder.</a> Vennligst spill ansvarlig. <a href="http://www.gamblingtherapy.org/no" target="_blank">www.Gamblingtherapy.org</a>',
  // 'create-account-promotion-terms-gb': '18+. New Players only. BeGambleAware. <a href="/index.php?page=promotions&amp;scrollto=welcome_promoterms" class="ui-link">Terms Apply</a>.',

  'personal-details-title': 'Registrer deg',
  'personal-details-supporting-text': '3 enkle steg',
  'address-details-title': 'Nesten der',
  'address-details-supporting-text': 'Her går det raskt!',
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'Dette er siste steget',

  // 'personal-details-title': 'Sign up', // Step 1
  // 'personal-details-supporting-text': '', // Step 1

  // 'address-details-title': 'Hallo %firstname%', // Step 2
  // 'address-details-supporting-text': 'Contact Information', // Step 2

  // 'account-details-title': 'Almost there',  // Step 3
  // 'account-details-supporting-text': 'Account Information', // Step 3

  // helpandsupport_contactinfo_h2
  // gi_account_information

  'marketing-preferences-title': 'Preferanser for markedsføring',
  'marketing-preferences-description':
    'Ursa Casino Tilbyr spillerne sine unike daglige tilbud og månedtlige høyedepunkter, som match bonuser, bonus spins, gratis spins, Cashback tilbud, turneringer, ekte premier, opplevelser og ferier. Vennligst sjekk ut under for å høre mer om dette:',
  'marketing-preferences-post-text': 'Du kan oppdatere dine markeds preferanser når som helst i "Min konto" seksjonen.',
  'marketing-preferences-label-cross-brand': 'Jeg vil høre mer om ekslusive tilbud fra ditt casino nettverk.',
  'marketing-preferences-label-brand-only': 'Jeg vil høre mer om ekslusive tilbud fra kun dette casinoet.',
  'marketing-preferences-label-email': 'Jeg vil høre om tilbudene via <strong>E-post</strong>',
  'marketing-preferences-label-sms': 'Jeg vil høre om tilbudene via <strong>sms</strong>',
  'marketing-preferences-label-phone-call': 'Jeg vil høre om tilbudene via <strong>oppringing på telefon</strong>',
  'marketing-preferences-label-post': 'Jeg vil høre om tilbudene via <strong>Post</strong>',

  'marketing-preferences-unified-description':
    'Ikke gå glipp av de seneste kampanjene fra Ursa Casino og de andre kasinoene innenfor <a href="/brands" target="_blank">vårt nettverk</a>. Velg hvordan du vil motta kommunikasjon fra oss.',
  'marketing-preferences-unified-label-email': 'E-post',
  'marketing-preferences-unified-label-sms': 'SMS',
  'marketing-preferences-unified-label-phone-call': 'Oppringing på telefon',
  'marketing-preferences-unified-label-phone-post': 'Post',
  'deposit-custom-footer':
    "<ul><li class='safe-support'>24/7 Support</li><li class='one-hundred-percent-secure'>100% sikkert</li><li class='usp-fast'>Raske og enkle uttak</li></ul>",

    'kyc-address-description': 'En strømregning eller konto utskrift.',
  'kyc-address-title': 'Bevis på adresse',
  'kyc-continue-upload': 'Fortsett å laste opp',
  'kyc-document-status-declined': 'Ikke mulig å godkjenne',
  'kyc-document-status-unknown': 'Ikke mulig å godkjenne',
  'kyc-document-status-not-required': 'Ikke obligatorisk',
  'kyc-go-to-my-account': 'Gå til Min konto',
  'kyc-id-description': 'Enten ditt førerkort, pass eller ID kort.',
  'kyc-id-title': 'Bevis på ID',
  'kyc-lock-description': 'Vennligst last opp følgende:',
  'kyc-lock-remark': 'Blir håndtert sikkert og blir aldri delt.',
  'kyc-lock-reviewing':
    'Dine dokumenter er under behandling. Vær oppmerksom på at dette kan ta opptil 48 timer. ' +
    'Du kommer til å motta en epost med mer informasjon når gjennomgangen er klar.',
  'kyc-lock-title-only-address': 'Bekreft adressen din',
  'kyc-lock-title-only-id': 'Bekreft identiteten din',
  'kyc-lock-title': 'Verifiser din identitet og adresse',
  'kyc-upload': 'Last opp',
  'kyc-verified-description': 'Dine dokumenter er godkjent',
  'kyc-verified-redirect-button': 'Se spill',
  'kyc-verified-title': 'Tusen takk',
  'kyc-lock-continue': 'Fortsett',
  'kyc-document-in-review': 'Under behandling...',
  'kyc-document-approved': 'Verifisert'
};
